import axios from "axios";
import ResponseAlerts from "../functions/ResponseAlerts";
import { server } from "../config/config";

const BASE_LOGS = "logs";

const RESOURCES = {
	LIST_ALL_LOGS: () => BASE_LOGS,

	LIST_LOGS_PAGINATED: (
		page,
		searchBy,
		orderBy,
		rowsPerPage,
		filters = {}
	) => {
		const params = new URLSearchParams();

		params.set("page", page);
		params.set("limit", 8);
		params.set("searchBy", searchBy || "");
		params.set("orderBy", orderBy?.collumnTitle || "");
		params.set("orderDirection", orderBy?.orderDirection || "");
		params.set("rowsPerPage", rowsPerPage || 8);

		Object.entries(filters).forEach(([key, value]) => {
			if (value !== undefined && value !== null && value !== "") {
				params.set(key, value);
			}
		});

		return `${BASE_LOGS}/paginated?${params.toString()}`;
	},

	DOWNLOAD_CSV: (name, orderBy) =>
		`${BASE_LOGS}/download-csv?name=${name}&orderBy=${orderBy}`,

	DOWNLOAD_CSV_WITH_FILTERS: (filters, orderBy) => {
		const searchParams = new URLSearchParams();
		searchParams.set("searchBy", filters.search ?? "");
		Object.entries(filters).forEach(([key, value]) => {
			if (key !== "search" && value !== undefined && value !== null && value !== "") {
				searchParams.set(key, value);
			}
		});
		if (orderBy?.collumnTitle) {
			searchParams.set("orderBy", orderBy.collumnTitle);
		}
		if (orderBy?.orderDirection) {
			searchParams.set("orderDirection", orderBy.orderDirection);
		}
		return `${BASE_LOGS}/download-csv?${searchParams.toString()}`;
	},
};

class LogsService {
	static async listAllLogs() {
		try {
			return await axios.get(RESOURCES.LIST_ALL_LOGS());
		} catch (error) {
			console.log(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: "Erro ao listar logs",
			});
			return error.response;
		}
	}

	static async listLogsPaginated(page, searchBy, orderBy, rowsPerPage, filters) {
		try {
			return await axios.get(
				RESOURCES.LIST_LOGS_PAGINATED(page, searchBy, orderBy, rowsPerPage, filters),
			);
		} catch (error) {
			console.log(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: "Erro ao listar logs",
			});
			return error.response;
		}
	}

	static async downloadCsv(filters, orderBy) {
		const token = localStorage.getItem("@BRVAuth:token");
		const response = await fetch(
			`${server.url}/${RESOURCES.DOWNLOAD_CSV_WITH_FILTERS(filters, orderBy)}`,
			{
				headers: {
					Authorization: `Bearer ${token}`,
				},
			},
		);

		if (!response.ok) {
			const errorData = await response.json().catch(() => ({}));
			ResponseAlerts({
				response: { status: response.status, data: errorData },
				errorMessage: errorData?.message ?? "Erro ao realizar download csv",
			});
			return null;
		}

		return response;
	}
}

export default LogsService;
